export function getPublicSiteOrigin() {
  const configuredCookieDomain = process.env.REACT_APP_AUTH_COOKIE_DOMAIN
    ?.trim()
    .replace(/^\.+/, "");
  if (configuredCookieDomain) {
    return `https://${configuredCookieDomain}`;
  }

  if (typeof window === "undefined") {
    return "";
  }

  const { protocol, hostname } = window.location;
  const normalizedHostname =
    hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1" || hostname === "[::1]"
      ? "localhost:3010"
      : hostname.startsWith("admin.")
        ? hostname.slice("admin.".length)
        : hostname;

  return `${protocol}//${normalizedHostname}`;
}
